import Vue from 'vue'
import router from './router/index'
import ElementUI, { MessageBox } from 'element-ui';
import './theme/index.css';
import App from './App.vue'
import axios from 'axios'
import dayjs from 'dayjs'
import TTUploader from 'tt-uploader';
import CopyText from './components/CopyText.vue'

import './assets/style/reset.css'
import './assets/style/theme-variables.css'
import './assets/style/dark-mode.css'
import './assets/style/mobile-admin.css'
import './assets/style/event-user-association.css'
import ThemeManager from './utils/theme.js'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

Vue.use(ElementUI);
Vue.component('copy-text', CopyText)
MessageBox.setDefaults({
  closeOnClickModal: false
});
Vue.config.productionTip = false

axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.prototype.$axios=axios
axios.defaults.baseURL = 'https://api2.jirou.fit/api'
// axios.defaults.baseURL = 'http://localhost:3000/api/'
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('bde_token')
  if (token) {
    config.headers = config.headers || {}
    config.headers['x-auth-token'] = config.headers['x-auth-token'] || token
  }
  return config
})

Vue.prototype.$dayjs=dayjs


const ttUploader = new TTUploader({
  // 必填，在我的应用中申请的appid
  appId: 376982,
  // 必填，建议设置能识别用户的唯一标识id，用于上传出错时排查问题，不要传入非 ASCII编码
  userId: 'musclepro_admin',
  // 必填，图片上传相关配置
  imageConfig: {
    // 必填，申请的图片服务id
    serviceId: '700tmnc25s'
  }
})

// 全局回调存储
const uploadCallbacks = {}

// 全局监听上传完成事件
ttUploader.on("complete", (data) => {
  const cb = uploadCallbacks[data.key];
  if (cb && data.type === "success") {
    cb.onSuccess && cb.onSuccess(data);
    delete uploadCallbacks[data.key];
  }
});

// 全局监听上传错误事件
ttUploader.on("error", (info) => {
  const cb = uploadCallbacks[info.key];
  if (cb) {
    cb.onError && cb.onError(info);
    delete uploadCallbacks[info.key];
  }
});

Vue.prototype.$ttUploader = ttUploader
Vue.prototype.$uploadCallbacks = uploadCallbacks

// Initialize theme before Vue app mounts
ThemeManager.init()

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
